module.exports = __webpack_public_path__ + "static/media/ag-staffNM.8ed0df3f.jpg";